import axios from '@/axios';

export default {
  getDispenseRequests(_context, dataTableParams) {
    return axios.get('/api/v1/dispense-request', { params: dataTableParams });
  },
  getDispenseRequest(_context, data) {
    return axios.get(`/api/v1/dispense-request/${data.id}`);
  },
  getPatientScripts(_context, data) {
    return axios.get(`/api/v1/dispense-request/patient-scripts/${data.patientId}?clinicId=${data.clinicId}`);
  },
  createNewDispenseRequest(_context, data) {
    return axios.post('/api/v1/dispense-request', data);
  },
  cancelDispenseRequest(_context, data) {
    return axios.post(`/api/v1/dispense-request/${data.id}/cancel`);
  },
  getDispenseRequestFee() {
    return axios.get('/api/v1/dispense-request/fees');
  },
};
